import { Component, ContentChildren, Input, ViewChild, ViewChildren } from "@angular/core";
import { QueryList } from "@angular/core";
import { VerticalCarouselItemComponent } from "../vertical-carousel-item/vertical-carousel-item.component";

/**
 * You need to specify a width and a height for this component.
 */
@Component({
    selector: 'tyt-vertical-carousel',
    templateUrl: './vertical-carousel.component.html',
    styleUrls: ['./vertical-carousel.component.scss']
})
export class VerticalCarouselComponent {
    @ContentChildren(VerticalCarouselItemComponent, { descendants: true })
    sections : QueryList<VerticalCarouselItemComponent>;

    ngAfterContentInit() {
        let count = this.sections.length;
        this.sections.changes.subscribe(() => {
            if (count === 0 && this.sections.length > 0) {
                this.currentItemIndex = -1;
                this.goToNextItem();
            }

            count = this.sections.length;
        });

        this.goToNextItem();
    }

    private _interval = 7000;

    @Input()
    interval : number;

    get currentItem() {
        return this.sections.toArray()[this.currentItemIndex];
    }

    goToNextItem() {
        if (this.sections.length === 0)
            return;
        this.setCurrentItem((this.currentItemIndex + 1) % this.sections.length);
        if (typeof window !== 'undefined') {
            let interval = this._interval;
            if (this.currentItem && this.currentItem.duration)
                interval = this.currentItem.duration;
            setTimeout(() => this.goToNextItem(), interval);
        }
    }

    private currentItemIndex = -1;

    private async turn() {
        return new Promise<void>(resolve => setTimeout(() => resolve()));
    }

    private async setCurrentItem(index : number, direction = 'next') {
        if (this.sections.length === 0)
            return;
        
        setTimeout(async () => {

            let lastActiveIndex = this.currentItemIndex;
    
            if (lastActiveIndex === index)
                return;

            this.currentItemIndex = index;
            let items = this.sections.toArray();
            let previousIndex = index === 0 ? items.length - 1 : index - 1;
            let nextIndex = (index + 1) % items.length;
    
            if (direction === 'next')
                items[index].next = true;
            else
                items[index].previous = true;
            items[index].hold = true;
    
            await this.turn();
    
            items.forEach(i => i.active = i.next = i.previous = false);
    
            items[index].next = items[index].previous = false;
            items[index].active = true;
            items[index].hold = false;
            
            if (direction === 'next') {
                if (previousIndex !== index)
                    items[previousIndex].previous = true;
            } else {
                if (nextIndex !== previousIndex && nextIndex !== index)
                    items[nextIndex].next = true;
            }
        });
    }
}